import {TypeLocalNameEnum} from 'domain/usecases';

import {useBookingStore} from 'presentation/modules/booking/shared/store/useBookingStore';
import {useGetExamsListQuery} from '../../queries/useGetExamsListQuery';
import {formatExamsList} from '../../utils/formatExamsList';
import {APIError} from 'data/errors';
import {HttpStatusCode} from 'data/protocols/http';

export function useExamList() {
	const bookingData = useBookingStore(state => state.bookingData);
	const isUsingGeolocation = !bookingData?.isManualLocation;

	const {
		data: examsList,
		error: examsListError,
		isError: examsListIsError,
		refetch,
		isFetching,
	} = useGetExamsListQuery({
		cityName: bookingData.cityName?.toUpperCase(),
		stateCode: bookingData.ufCode?.toUpperCase(),
		typeLocalName: isUsingGeolocation ? TypeLocalNameEnum.CIDADE : bookingData.typeLocalName,
	});

	const examsListFormatted = examsList && formatExamsList(examsList);

	const examListHasUnprocessableError =
		examsListError &&
		examsListError instanceof APIError &&
		examsListError.statusCode === HttpStatusCode.unprocessable;

	return {
		examsList: examsListFormatted,
		examsListError,
		examsListIsError,
		refetchExamsList: refetch,
		isFetchingExamsList: isFetching,
		examListRaw: examsList,
		examListHasUnprocessableError,
	};
}
